import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Detail, DetailSkeleton } from '../../../subcomponents/detail/detail';
import { HeadingLevel } from '../../../subcomponents/heading/heading';
import { getFilmSynopsisByLength } from '../../../utils/get-film-synopsis-by-length';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultFilmSynopsisProps, filmSynopsisPropsValidator } from './types/props';
const b = bemClassBuilder('v-film-synopsis');
export const FilmSynopsis = observer(props => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText, config } = props;
    const { film } = useFilmContext();
    if (!film)
        return enableSkeletonLoadingIndicators ? _jsx(FilmSynopsisSkeleton, {}) : null;
    const synopsis = getFilmSynopsisByLength(film, config.length);
    if (!synopsis)
        return null;
    return (_jsx(Detail, { className: b.block(), headingLevel: HeadingLevel.H3, heading: displayText.label, content: i18n.translatable(synopsis) }));
});
FilmSynopsis.displayName = 'FilmSynopsis';
export const FilmSynopsisSkeleton = () => _jsx(DetailSkeleton, { className: b.block({ skeleton: true }) });
FilmSynopsisSkeleton.displayName = 'FilmSynopsisSkeleton';
/**
 * The **Film Synopsis** component renders a film's synopsis.
 */
export const FilmSynopsisComponent = withComponentWrapper(FilmSynopsis, defaultFilmSynopsisProps, filmSynopsisPropsValidator);
